import { useStrictLocalization } from "@faire/web/common/localization";
import React from "react";

import { FaireHelmet } from "@faire/retailer/components/Helmet";
import { useFaireDirectBrand } from "@faire/retailer/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { useAppSnackbarStore } from "@faire/retailer/stores/ui/AppSnackbarStore";
import {
  getMetaDescription,
  getMetaTitle,
} from "@faire/retailer/views/product/__internal__/SEOMetaText";

export const SEOProductInfo: React.FC<{
  productName: string | undefined;
  productDescription: string | undefined;
  brandCompanyName: string | undefined;
}> = ({ productName, productDescription, brandCompanyName }) => {
  const { strictLocalize } = useStrictLocalization();
  const [{ productTitle }] = useAppSnackbarStore(["productTitle"]);
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const { isFaireDirectActiveInLoggedOut } = useFaireDirectBrand();
  const title = isLoggedInRetailer
    ? getMetaTitle(
        {
          productName: productTitle,
          isFaireDirectActiveInLoggedOut,
        },
        strictLocalize,
        false
      )
    : getMetaTitle(
        { productName, isFaireDirectActiveInLoggedOut },
        strictLocalize
      );

  const description = getMetaDescription(
    {
      productName,
      brandCompanyName,
      productDescription,
      isFaireDirectActiveInLoggedOut,
    },
    strictLocalize
  );

  return <FaireHelmet title={title} description={description} />;
};
SEOProductInfo.displayName = "SEOProductInfo";
